import React, { ReactNode } from 'react';

import CenteredLayoutContainer from 'components/CenteredLayoutContainer';
import { H1 } from 'components/Heading';

import { Layout } from './Layout';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const CenteredLayout = ({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) => (
  <Layout defaultWithSearchHero={false}>
    <CenteredLayoutContainer
      pt={[null, null, null, 60]}
      pb={[null, null, null, 40]}
    >
      {title && <H1 styleAs="h2">{title}</H1>}
      {children}
    </CenteredLayoutContainer>
  </Layout>
);

// eslint-disable-next-line import/no-default-export
export default CenteredLayout;
